import * as React from 'react';
import { TextField } from '@symphony-ui/uitoolkit-components';
import Spread from '../../../../../../models/data/Spread';
import GenericBenchmarkPicker from './GenericBenchmarkPicker';
import PopupContext from 'contexts/PopupContext';
const SpreadEditor = ({ onChange, value }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [typePicker, setTypePicker] = React.useState(value?.benchmark === undefined);
    const [text, setText] = React.useState(value?.value?.toString() ?? '');
    const onChangeText = React.useCallback((event) => {
        setText(event.target.value);
        const newSpread = new Spread({ value: Number.parseFloat(event.target.value), benchmark: value?.benchmark });
        onChange({ target: { value: newSpread } });
    }, [onChange, value?.benchmark]);
    const saveBenchmark = React.useCallback((benchmark) => {
        const newSpread = new Spread({ benchmark, value: Number.parseFloat(text) });
        onChange({ target: { value: newSpread } });
        setTypePicker(false);
        setBlockClose(false);
    }, [onChange, setBlockClose, text]);
    const onClick = React.useCallback(() => {
        setBlockClose(true);
        setTypePicker(true);
    }, [setBlockClose]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("span", { onClick: onClick, style: { alignSelf: 'center', marginRight: '0.5rem' } }, value?.benchmark?.print()),
            React.createElement("span", { style: { fontSize: 'x-large', alignSelf: 'end', marginBottom: '0.25rem', marginRight: '0.25rem' } }, "+"),
            React.createElement(TextField, { onChange: onChangeText, value: text })),
        typePicker ? React.createElement(GenericBenchmarkPicker, { initial: value?.benchmark, setInitialBenchmark: saveBenchmark })
            : undefined));
};
export default SpreadEditor;
